
import React, { useState, useRef, useEffect } from "react";
import { Link } from 'react-router-dom';

import useApi from '../../utility/apiCall';
import API_URL from '../../config/config';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth, getLoggedInUserData } from '../../context/AuthContext';
import FlashMessage from '../../components/FlashMessage';
import Button from 'react-bootstrap/Button';
import EmptyBox from '../../components/EmptyBox';

// React Bootstrap
import { Modal } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Components File
import AccountChart from '../ComomonChart/AccountChart';
import LimitCardItem from './LimitCardItem';
import ScaleOverviewItem from './ScaleOverviewItem';

// Icons & Images Files
import Icons from '../../components/icons';
import DropItem from '../../components/commonfield/DropItem';
import master from "../../img/icons/account/master.png"
import practitioner from "../../img/icons/account/practitioner.png"
import student from "../../img/icons/account/student.png"
import balanceImg from "../../img/icons/balance.svg"
import equityImg from "../../img/icons/equity.svg"
import Loaders from '../../components/Loader';
// datepaicker summary
import { format, addMonths, subMonths, startOfMonth, endOfMonth, startOfWeek, endOfWeek, addDays, isSameMonth, isSameDay, isNextDay } from 'date-fns';
import { Icon } from "@mui/material";
import { getDaysInYear } from "date-fns/fp/getDaysInYear";
import AccountStatus from "../../components/AccountStatus";
import Alert from "../../components/Alert";
import CalendarNavigation from "../../components/CalendarNavigation";
import Pagination from "../../components/Pagination";
import CloseIcon from "../../components/CloseIcon";
import SortIcons from "../../components/SortIcons";
import Breadcrumb from "../../components/Breadcrumb";


const Equity2Svg = () => {
  return (

    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.54163 5.83325C1.54163 4.10736 2.94074 2.70825 4.66663 2.70825C6.39252 2.70825 7.79163 4.10736 7.79163 5.83325C7.79163 7.55914 6.39252 8.95825 4.66663 8.95825C2.94074 8.95825 1.54163 7.55914 1.54163 5.83325Z" fill="#35F8F8" />
      <path d="M3.20825 15.0001C3.20825 12.814 4.98046 11.0417 7.16659 11.0417C9.35271 11.0417 11.1249 12.814 11.1249 15.0001C11.1249 17.1862 9.35271 18.9584 7.16659 18.9584C4.98046 18.9584 3.20825 17.1862 3.20825 15.0001Z" fill="#35F8F8" />
      <path d="M9.87518 5.83341C9.87518 3.18705 12.0205 1.04175 14.6668 1.04175C17.3132 1.04175 19.4585 3.18705 19.4585 5.83341C19.4585 8.47978 17.3132 10.6251 14.6668 10.6251C12.0205 10.6251 9.87518 8.47978 9.87518 5.83341Z" fill="#35F8F8" />
    </svg>

  )
}

const Ewallets2Svg = () => {
  return (


    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.78893 3.38559C7.87779 3.52105 7.77748 3.75199 7.57686 4.21386C7.49964 4.39164 7.42958 4.57324 7.36705 4.75832C7.29287 4.97783 7.25578 5.08759 7.17737 5.14385C7.09897 5.20012 6.99012 5.20012 6.77242 5.20012H4.18137C3.64164 5.20012 3.2041 5.63664 3.2041 6.17512C3.2041 6.71359 3.64164 7.15011 4.18137 7.15011L15.9776 7.15011C16.8093 7.13744 18.6295 7.14287 19.2563 7.2659C20.1631 7.38753 20.9639 7.6527 21.6051 8.2924C22.2462 8.9321 22.512 9.73104 22.6339 10.6357C22.7501 11.4973 22.75 12.586 22.75 13.9063V15.9939C22.75 17.3141 22.7501 18.4028 22.6339 19.2645C22.512 20.1691 22.2462 20.9681 21.6051 21.6078C20.9639 22.2475 20.1631 22.5126 19.2563 22.6343C18.3926 22.7501 17.3014 22.7501 15.978 22.75H9.97398C8.19196 22.7501 6.75559 22.7501 5.6259 22.5986C4.45303 22.4412 3.4655 22.1047 2.68118 21.3222C1.89687 20.5397 1.55952 19.5545 1.40183 18.3843C1.24995 17.2573 1.24997 15.8243 1.25 14.0464V6.17513C1.25 4.5597 2.56262 3.25014 4.18182 3.25014L6.99624 3.25013C7.46547 3.25013 7.70008 3.25012 7.78893 3.38559ZM17.5 12.9999C18.6046 12.9999 19.5 13.8953 19.5 14.9999C19.5 16.1044 18.6046 16.9999 17.5 16.9999C16.3954 16.9999 15.5 16.1044 15.5 14.9999C15.5 13.8953 16.3954 12.9999 17.5 12.9999Z" fill="#35F8F8" />
      <path d="M19.4557 6.03151C19.563 6.0463 19.6555 5.95355 19.6339 5.84742C19.1001 3.22413 16.7803 1.25 13.9994 1.25C11.3264 1.25 9.07932 3.07399 8.43503 5.54525C8.38746 5.72772 8.52962 5.90006 8.7182 5.90006L15.9679 5.90006C16.3968 5.89365 17.0712 5.89192 17.7232 5.90742C18.3197 5.92161 19.0159 5.95164 19.4557 6.03151Z" fill="#35F8F8" />
    </svg>


  )
}

const ArrowLeftDownSvg = () => {
  return (


    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 4.5-15 15m0 0h11.25m-11.25 0V8.25" />
    </svg>




  )
}

const ArrowRightUpSvg = () => {
  return (


    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25" />
    </svg>



  )
}

export default function PageAccountDetail() {

  //Auth related var

  const { apiCall } = useApi();
  const navigate = useNavigate();
  const { state, dispatch } = useAuth();
  const token = state.token || '';
  const isInitialMount = useRef(true);

  const { id } = useParams();


  const [chartType, setChartType] = useState('line');

  //Loader
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingnew, setIsLoadingnew] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [requestSubmitError, setRequestSubmitError] = useState(false);
  const [requestSubmitErrorMsg, setRequestSubmitErrorMsg] = useState(false);
  const [requestSubmitSuccess, setRequestSubmitSuccsess] = useState(false);
  const [requestSubmitSuccessMsg, setRequestSubmitSuccessMsg] = useState(false);
  const [currentAccount, setCurrentAccount] = useState([]);

  // ---
  const [isCredentialsModal, setIsCredentialsModal] = useState(false);

  const [selectedOption, setSelectedOption] = useState('daily');
  const options = ['daily', 'week', 'month'];

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    console.log('Selected Option:', option);

    // Call getProfitDataChart with the new option
    getProfitDataChart(id, option);
  };


  // trading history table var
  const [tradingHistoryList, setTradingHistoryList] = useState([]);
  const [pageTradingHistory, setPageTradingHistory] = useState(1);
  const [goPageTradingHistory, setGoPageTradingHistory] = useState(null);
  const [totalPagesTradingHistory, setTotalPagesTradingHistory] = useState(0);

  // const onChangePageTradingHistory = (pageTradingHistory) => {
  //   // console.log('pageTradingHistory', pageTradingHistory.target.value);
  //   if (pageTradingHistory.target.value == "") {
  //     pageTradingHistory.target.value = 1;
  //   }
  //   console.log('totalPagesTradingHistory', totalPagesTradingHistory);
  //   if (pageTradingHistory.target.value < parseInt(totalPagesTradingHistory)) {
  //     setPageTradingHistory(pageTradingHistory.target.value);
  //     setGoPageTradingHistory(pageTradingHistory.target.value);
  //   } else {
  //     setPageTradingHistory(totalPagesTradingHistory);
  //     setGoPageTradingHistory(totalPagesTradingHistory);
  //   }
  // }

  const onChangePageTradingHistory = (pageTradingHistory) => {
    setPageTradingHistory(pageTradingHistory);
  }

  const changePrevPageTradingHistory = () => {
    if (pageTradingHistory > 1) {
      setPageTradingHistory(pageTradingHistory - 1);
      // setGoPageTradingHistory(pageTradingHistory - 1);
      onChangePageTradingHistory(pageTradingHistory - 1)
    }

  }
  const changeNextPageTradingHistory = () => {
    if (pageTradingHistory < totalPagesTradingHistory) {
      setPageTradingHistory(pageTradingHistory + 1);
      // setGoPageTradingHistory(pageTradingHistory + 1);
      onChangePageTradingHistory(pageTradingHistory + 1)

    }
  }
  // open trading table var
  const [openTradingList, setOpenTradingList] = useState([]);
  const [pageOpenTrading, setPageOpenTrading] = useState(1);
  const [goPageOpenTrading, setGoPageOpenTrading] = useState(null);
  const [totalPagesOpenTrading, setTotalPagesOpenTrading] = useState(0);

  // const onChangePageOpenTrading = (pageOpenTrading) => {
  //   if (pageOpenTrading.target.value == "") {
  //     pageOpenTrading.target.value = 1;
  //   }
  //   if (pageOpenTrading.target.value < parseInt(totalPagesOpenTrading)) {
  //     setPageOpenTrading(pageOpenTrading.target.value);
  //     setGoPageOpenTrading(pageOpenTrading.target.value);
  //   } else {
  //     setPageOpenTrading(totalPagesOpenTrading);
  //     setGoPageOpenTrading(totalPagesOpenTrading);
  //   }
  // }

  const onChangePageOpenTrading = (pageOpenTrading) => {
    setPageOpenTrading(pageOpenTrading)
  }

  const changePrevPageOpenTrading = () => {
    if (pageOpenTrading > 1) {
      setPageOpenTrading(pageOpenTrading - 1);
      onChangePageOpenTrading(pageOpenTrading - 1);
    }
  }

  const changeNextPageOpenTrading = () => {
    if (pageOpenTrading < totalPagesOpenTrading) {
      setPageOpenTrading(pageOpenTrading + 1);
      onChangePageOpenTrading(pageOpenTrading + 1);
    }
  }




  // Daily summary trading table var
  const [dailySummaryTradingList, setDailySummaryTradingList] = useState([]);
  const [pageDailySummary, setPageDailySummary] = useState(1);
  // const [goPageDailySummary, setGoPageDailySummary] = useState(null);
  const [totalPagesDailySummary, setTotalPagesDailySummary] = useState(0);

  // const onChangePageDailySummary = (pageDailySummary) => {
  //   if (pageDailySummary.target.value == "") {
  //     pageDailySummary.target.value = 1;
  //   }
  //   if (pageDailySummary.target.value < parseInt(totalPagesDailySummary)) {
  //     setPageDailySummary(pageDailySummary.target.value);
  //     setGoPageDailySummary(pageDailySummary.target.value);
  //   } else {
  //     setPageDailySummary(totalPagesDailySummary);
  //     setGoPageDailySummary(totalPagesDailySummary);
  //   }
  // }

  const onChangePageDailySummary = (pageDailySummary) => {
    setPageDailySummary(pageDailySummary)
  }

  const changePrevPageDailySummary = () => {
    if (pageDailySummary > 1) {
      setPageDailySummary(pageDailySummary - 1);
      onChangePageDailySummary(pageDailySummary - 1);
    }

  }
  const changeNextPageDailySummary = () => {
    console.log(pageDailySummary);
    console.log(totalPagesDailySummary);
    if (pageDailySummary < totalPagesDailySummary) {
      setPageDailySummary(pageDailySummary + 1);
      onChangePageDailySummary(pageDailySummary + 1);
    }
  }

  // Other info var
  const [accountNumber, setAccountNumber] = useState('');
  const [createDate, setCreateDate] = useState('');
  const [accountStatus, setAccountStatus] = useState('');
  const [accountType, setAccountType] = useState('');
  const [accountPhase, setAccountPhase] = useState('');
  const [userWalletParentID, setUserWalletParentID] = useState('');
  const [mt5Type, setMt5Type] = useState('');

  const [accountBalance, setAccountBalance] = useState(0);
  const [accountSize, setAccountSize] = useState(0);
  const [accountEquity, setAccountEquity] = useState(0);
  const [email, setEmail] = useState('');
  const [masterPassword, setMasterPassword] = useState('');
  const [startTradePeriod, setStartTradePeriod] = useState('');
  const [endTradePeriod, setEndTradePeriod] = useState('');
  const [avgWin, setAvgWin] = useState(0);
  const [avgLoss, setAvgLoss] = useState(0);



  // analysis var
  const [numberOfDays, setNumberOfDays] = useState(0);
  const [totalTradesTaken, setTotalTradesTaken] = useState(0);
  const [avgTradesPerDay, setAvgTradesPerDay] = useState(0);
  const [totalLotsUsed, setTotalLotsUsed] = useState(0);
  const [avgLotsUsed, setAvgLotsUsed] = useState(0);
  const [biggestWin, setBiggestWin] = useState(0);
  const [biggestLoss, setbiggestLoss] = useState(0);
  const [positiveDay, setPositiveDay] = useState(0);
  const [negativeDay, setNegativeDay] = useState(0);


  const [dailyMaxLossLimit, setDailyMaxLossLimit] = useState(0);
  const [maxOverallLossLimit, setMaxOverallLossLimit] = useState(0);
  const [profitTarget, setProfileTarget] = useState(0);
  const [dailyMaxThreadShold, setDailyMaxThreadShold] = useState(0);
  const [maxOverallLossThreadShold, setMaxOverallLossThreadShold] = useState(0);
  const [makeOverAllLossPercentage, setMakeOverAllLossPercentage] = useState(0);
  const [makeDailyLossPercentage, setMakeDailyLossPercentage] = useState(0);
  const [makeOverAllProfitPercentage, setMakeOverAllProfitPercentage] = useState(0);
  const [maxTradingDays, setMaxTradingDays] = useState(0);
  const [countMaxTradingDaysLeft, setCountMaxTradingDaysLeft] = useState(0);
  const [countMaxTradingDaysLeftPercentage, setCountMaxTradingDaysLeftPercentage] = useState(0);
  const [minBalance, setMinBalance] = useState(0);
  const [maxBalance, setMaxBalance] = useState(0);
  const [minEquity, setMinEquity] = useState(0);
  const [maxEquity, setMaxEquity] = useState(0);
  const [remainDailyLoss, setRemainDailyLoss] = useState(0);
  const [remainMaxLoss, setRemainMaxLoss] = useState(0);
  const [remainMaxProfit, setRemainMaxProfit] = useState(0);
  const [totalLoss, setTotalLoss] = useState(0);
  const [totalProfit, setTotalProfit] = useState(0);
  const [winRatio, setWinRatio] = useState(0);
  const [checkRealAccountIsCreated, setCheckRealAccountIsCreated] = useState(0);
  const [checkPassedAccountIsCreated, setCheckPassedAccountIsCreated] = useState(0);
  const [checkRealAccountIsApproved, setCheckRealAccountIsApproved] = useState(0);
  const [checkRealAccountIsRejected, setCheckRealAccountIsRejected] = useState(0);
  const [checkPassedAccountIsApproved, setCheckPassedAccountIsApproved] = useState(0);
  const [checkPassedAccountIsRejected, setCheckPassedAccountIsRejected] = useState(0);
  const [passedAccountRequest, setPassedAccountRequest] = useState(false);
  const [drawDownReason, setDrawDownReason] = useState('');

  const [applyForRealAccount, setApplyForRealAccount] = useState(0);

  const [filterValue, setFilterValue] = useState('daily');


  const [showCustomFilter, setShowCustomFilter] = useState(false);


  const [profitChartData, setProfitChartData] = useState([]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [showCertificate, setShowCertificate] = useState(0);

  const handleButtonFilterChartClick = (event) => {
    const buttons = document.querySelectorAll('.dashbord-filter button');
    buttons.forEach((button) => button.classList.remove('active'));
    event.target.classList.add('active');

    // Show custom filter only if "Custom" button is clicked
    if (event.target.value === 'custom') {
      // console.log(startDate);
      // console.log(endDate);
      setFilterValue(event.target.value);
      setShowCustomFilter(true);
    } else {
      setFilterValue(event.target.value);
      setShowCustomFilter(false);

    }
  };

  function calculateTimeLeft() {
    const now = new Date();
    const endOfDay = new Date();
    endOfDay.setHours(23, 59, 59, 0); // 11:59:59 PM

    let timeDiff = endOfDay.getTime() - now.getTime();

    if (timeDiff < 0) {
      timeDiff = 0; // If end of day has passed, set to zero
    }

    const hours = Math.floor(timeDiff / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    return {
      hours: hours.toString().padStart(2, '0'),
      minutes: minutes.toString().padStart(2, '0'),
      seconds: seconds.toString().padStart(2, '0')
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const copyClick = (value) => {
    setRequestSubmitSuccsess(false);
    setRequestSubmitError(false);
    navigator.clipboard.writeText(value)
      .then(() => {
        setRequestSubmitSuccsess(true);
        setRequestSubmitSuccessMsg('Text copied to clipboard');
        // console.log('Text copied to clipboard');
      })
      .catch((error) => {
        setRequestSubmitError(true)
        setRequestSubmitErrorMsg('Error copying text')
        // console.error('Error copying text: ', error);
      });
  };

  const anotherFormatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };

    return date.toLocaleString('en-US', options);
  };


  const handleCredentialsModalClose = () => {
    setIsCredentialsModal(false);
  };


  const formatStatus = (status) => {
    if (!status) return ''; // Handle case where status might be undefined or null
    if (status == 'passed') {
      status = 'Profit target achieved';
    }
    const formattedStatus = status.replace(/_/g, ' '); // Replace underscores with spaces
    return formattedStatus.charAt(0).toUpperCase() + formattedStatus.slice(1); // Capitalize first letter
  };
  const handleCredentialsModalShow = async (challengeID) => {
    try {
      const response = await apiCall(API_URL + 'get-challenge-details', {
        user_id: state.userData.id,
        id: challengeID,
        token: token
      });
      if (response.data.success == '0') {
        // console.log(response.data);
        setEmail(response.data.data.email);
        setAccountNumber(response.data.data.account_number);
        setMasterPassword(response.data.data.master_password);
        setIsCredentialsModal(true);
        // setChallengeDetails(response.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    setIsCredentialsModal(true);
  }
  // ---

  // ---
  const [isSnapshotModal, setIsSnapshotModal] = useState(false);
  const [snapShotTitle, setSnapShotTitle] = useState(false);

  const handleSnapshotModalClose = () => {
    setIsSnapshotModal(false);
  };
  // ---


  // ---
  const [isAnalysisModal, setIsAnalysisModal] = useState(false);

  const handleAnalysisModalClose = () => {
    setIsAnalysisModal(false);
  };

  const handleAnalysisModalShow = async (title) => {
    // setIsAnalysisModal(true);
    try {
      const response = await apiCall(API_URL + 'get-analysis-data', {
        user_id: state.userData.id,
        userWalletID: id,
        token: token
      });
      if (response.data.success == '0') {
        setSnapShotTitle(title);
        setNumberOfDays(response.data.data.numberOfDays)
        setTotalTradesTaken(response.data.data.totalTradesTaken)
        setAvgTradesPerDay(response.data.data.averageTradesPerDay)
        setTotalLotsUsed(response.data.data.totalLotsUsed)
        setAvgLotsUsed(response.data.data.averageLotsUsed)
        setBiggestWin(response.data.data.biggestWin)
        setbiggestLoss(response.data.data.biggestLoss)
        setPositiveDay(response.data.data.positiveDays)
        setNegativeDay(response.data.data.negativeDays)
        setIsAnalysisModal(true);
        // setChallengeDetails(response.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    setIsAnalysisModal(true);
  }


  // ---

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [changeMonth, setChangeMonth] = useState();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [changeSelectedDate, setChangeSelectedDate] = useState();

  const [dataForCalender, setDataForCalender] = useState(null);


  const [tradeTakenSelectedDay, setTradeTakenSelectedDay] = useState();
  const [endingBalanceSelectedDay, setEndingBalanceSelectedDay] = useState();
  const [usedLotsSelectedDay, setUsedLotsSelectedDay] = useState();
  const [amountSelectedDay, setAmountSelectedDay] = useState(0);
  const [photoUrl, setPhotoUrl] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const loggedInUser = getLoggedInUserData();
      const isUserLoggedIn = !!loggedInUser;

      if (isUserLoggedIn) {
        if (loggedInUser.id && token) {
          try {
            // getIbRequestStatus();
            // const profitChart = await getProfitDataChart();
            // const tradeHistory = await getTradingHistoryList();
            // const openTrade = await getOpenTradingList();
            // const dailySummary = await getDailySummaryTradingList();
            // const calenderSummary = await getDataForAccountDetailsCalender();
            const userDetail = await getUserProfile();
            const tradeDashboard = await getTradDashboardDetails();
            const tradeDashboardreal = await getRealTimeDataForAccountDetail();
            setDataLoaded(true);
          } catch (error) {
            navigate('/login');
            console.error('Failed to fetch ib data:', error);
          }
        }
      }
    };

    if (isInitialMount.current) {
      isInitialMount.current = false;
      fetchData();
    }
  }, [token]);

  const [sortFieldone, setSortFieldone] = useState('open_date'); // Default sort by date
  const [sortDirectionone, setSortDirectionone] = useState('desc');


  const getTradingHistoryList = async () => {
    try {
      setIsLoadingnew(true);
      // console.log({id});
      const response = await apiCall(API_URL + 'get-trading-history-list', {
        user_id: state.userData.id,
        token: token,
        page: pageTradingHistory,
        per_page: 5,
        user_wallet_id: id,
        sort_field: sortFieldone, // Pass sort field
        sort_direction: sortDirectionone, // Pass sort direction
      });
      if (response.data.success == '0') {
        // console.log('trading list history',response.data.data.last_page);
        setTradingHistoryList(response.data.data.data)
        setTotalPagesTradingHistory(response.data.data.last_page)
      }
      setIsLoadingnew(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const handleSortone = (field) => {
    if (sortFieldone === field) {
      // Toggle direction when the same field is clicked
      setSortDirectionone(sortDirectionone === 'asc' ? 'desc' : 'asc');
    } else {
      // Set the field to be sorted by, default to ascending
      setSortFieldone(field);
      setSortDirectionone('asc');
    }
  };
  useEffect(() => {
    getTradingHistoryList();
  }, [sortFieldone, sortDirectionone, pageTradingHistory]);

  const getDataForAccountDetailsCalender = async () => {
    try {
      // setIsLoading(true);
      // console.log({id});
      const response = await apiCall(API_URL + 'get-data-for-account-details-calender', {
        user_id: state.userData.id,
        token: token,
        user_wallet_id: id,
        year: format(currentMonth, 'yyyy'),
        month: format(currentMonth, 'M')
      });
      if (response.data.success == '0') {
        // console.log('datatatatatacashgvkasfgasukdjfvashukfbukdhvbdla',response.data);
        setDataForCalender(response.data)
        // setTotalPagesTradingHistory(response.data.data.last_page)
      }
      // setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  const getDataForAccountDetailsDateWise = async () => {
    try {
      // setIsLoading(true);
      // console.log({id});
      // console.log('before', selectedDate);
      const response = await apiCall(API_URL + 'get-data-for-account-details-date-wise', {
        user_id: state.userData.id,
        token: token,
        user_wallet_id: id,
        select_date: selectedDate
      });
      if (response.data.success == '0') {
        console.log('abc', response.data.data.profit - response.data.data.loss);
        const netAmount = response.data.data.profit - response.data.data.loss;
        setTradeTakenSelectedDay(response.data.data.count);
        setEndingBalanceSelectedDay(response.data.data.ending_balance);
        setUsedLotsSelectedDay(response.data.data.lots);
        setAmountSelectedDay(netAmount);
      }
      // setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };



  const getProfitDataChart = async (userWalletId, filterOption) => {
    try {
      // setIsLoading(true);
      // console.log({id});
      const response = await apiCall(API_URL + 'get-trade-data-for-chart', {
        user_id: state.userData.id,
        token: token,
        user_wallet_id: id,
        filter_apply_value: filterOption,
      });
      if (response.data.success == '0') {
        console.log('trading list history', response.data.data.profitData);
        setProfitChartData(response.data.data.profitData);
        // setProfitChartData(response.data.data.data)
      }
      // setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    getProfitDataChart(id, filterValue);
  }, [filterValue]);

  // useEffect(() => {
  //   getProfitDataChart();
  // },[]);

  useEffect(() => {
    if (parseInt(pageTradingHistory) > 0) {
      getTradingHistoryList();
    }
  }, [pageTradingHistory]);

  // useEffect(() => {
  //   // if(parseInt(pageOpenTrading) > 0){
  //   // }
  //   getOpenTradingList();
  // }, [pageOpenTrading]);

  useEffect(() => {
    if (parseInt(pageDailySummary) > 0) {
      getDailySummaryTradingList();
    }
  }, [pageDailySummary]);

  const getTradDashboardDetails = async () => {
    try {
      setIsLoading(true);
      // console.log({id});
      const response = await apiCall(API_URL + 'get-trade-dashboard-details', {
        user_id: state.userData.id,
        token: token,
        userWalletID: id
      });
      if (response.data.success == '0') {
        //console.log(response.data.data.challengeInfo);
        const dashboardDetails = response.data.data;
        setAccountNumber(dashboardDetails.challengeInfo.account_number);
        setCreateDate(dashboardDetails.challengeInfo.created_at);
        setAccountStatus(dashboardDetails.challengeInfo.account_status);
        setAccountType(dashboardDetails.challengeInfo.account_type.step);
        setMt5Type(dashboardDetails.challengeInfo.mt5_type);
        setAccountPhase(dashboardDetails.challengeInfo.account_type.name);
        setUserWalletParentID(dashboardDetails.challengeInfo.parent_user_wallet_id ? dashboardDetails.challengeInfo.parent_user_wallet_id : '');
        setAccountSize(dashboardDetails.challengeInfo.account_size.limit);
        setAccountBalance(dashboardDetails.challengeInfo.available_balance);
        setAccountEquity(dashboardDetails.challengeInfo.equity);
        setStartTradePeriod(dashboardDetails.startPeriodDate.created_at);
        setEndTradePeriod(dashboardDetails.endPeriodDate.created_at);
        setAvgWin(dashboardDetails.winAverage);
        setAvgLoss(dashboardDetails.lossAverage);
        setProfileTarget(dashboardDetails.profitTarget)
        setMakeOverAllProfitPercentage(dashboardDetails.makeOverAllProfitPercentage)
        setMaxTradingDays(dashboardDetails.maxTradingDays)
        setCountMaxTradingDaysLeft(dashboardDetails.countMaxTradingDaysLeft)
        setCountMaxTradingDaysLeftPercentage(dashboardDetails.countMaxTradingDaysLeftPercentage)
        setMinBalance(dashboardDetails.minBalance);
        setMaxBalance(dashboardDetails.maxBalance);
        setMinEquity(dashboardDetails.minEquity);
        setMaxEquity(dashboardDetails.maxEquity);
        setRemainDailyLoss(dashboardDetails.remainDailyLoss);
        setRemainMaxLoss(dashboardDetails.remainMaxLoss);
        setRemainMaxProfit(dashboardDetails.remainMaxProfit);
        setTotalLoss(dashboardDetails.totalLoss);
        setTotalProfit(dashboardDetails.totalProfit);
        setWinRatio(dashboardDetails.winRatio);
        setPassedAccountRequest(dashboardDetails.passedAccountRequest);
        setCheckRealAccountIsCreated(dashboardDetails.checkRealAccountIsCreated);
        setCheckRealAccountIsRejected(dashboardDetails.checkRealAccountIsRejected);
        setCheckRealAccountIsApproved(dashboardDetails.checkRealAccountIsApproved);
        setCheckPassedAccountIsCreated(dashboardDetails.checkPassedAccountIsCreated);
        setCheckPassedAccountIsRejected(dashboardDetails.checkPassedAccountIsRejected);
        setCheckPassedAccountIsApproved(dashboardDetails.checkPassedAccountIsApproved);
        setShowCertificate(dashboardDetails.showCertificate);
        if (dashboardDetails.challengeInfo.disable_rule) {
          if (dashboardDetails.challengeInfo.disable_rule == '30% rule breach') {
            setDrawDownReason('30% rule breach');
          } else if (dashboardDetails.challengeInfo.disable_rule == 'Daily drawdown') {
            setDrawDownReason('Daily Loss Exceeded!');
          } else {
            setDrawDownReason('Maximum Loss Exceeded!');
          }
        } else {
          setDrawDownReason('Maximum Loss Exceeded!');
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const getOpenTradingList = async () => {
    try {
      // setIsLoading(true);
      // console.log({id});
      const response = await apiCall(API_URL + 'get-open-positions-list', {
        user_id: state.userData.id,
        token: token,
        page: pageOpenTrading,
        per_page: 5,
        user_wallet_id: id
      });
      if (response.data.success == '0') {
        setOpenTradingList(response.data.data.data)
        setTotalPagesOpenTrading(response.data.data.last_page)
      }
      // setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const [sortField, setSortField] = useState('close_date'); // Default sort by date
  const [sortDirection, setSortDirection] = useState('desc'); // Default direction

  const getDailySummaryTradingList = async () => {
    try {
      setIsLoading(true);
      const response = await apiCall(API_URL + 'get-daily-summary-trade-list', {
        user_id: state.userData.id,
        token: token,
        page: pageDailySummary,
        per_page: 5,
        user_wallet_id: id,
        sort_field: sortField, // Pass sort field
        sort_direction: sortDirection, // Pass sort direction

      });

      if (response.data.success == '0') {
        setDailySummaryTradingList(response.data.data.data);
        setTotalPagesDailySummary(response.data.data.last_page);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  const handleSort = (field) => {
    if (sortField === field) {
      // Toggle direction when the same field is clicked
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // Set the field to be sorted by, default to ascending
      setSortField(field);
      setSortDirection('asc');
    }
  };


  // Trigger the fetch when sorting changes
  useEffect(() => {
    getDailySummaryTradingList();
  }, [sortField, sortDirection, pageDailySummary]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (accountStatus !== 'disabled') {
        getRealTimeDataForAccountDetail();
      }
    }, 15000);

    if (accountStatus == 'disabled') {
      clearInterval(interval);
    }

    return () => clearInterval(interval); // Cleanup on unmount
  }, [token, id, accountStatus]);

  const getRealTimeDataForAccountDetail = async () => {
    try {
      // setIsLoading(true);
      // console.log({id});
      const response = await apiCall(API_URL + 'get-real-time-data-for-account-details', {
        user_id: state.userData.id,
        token: token,
        user_wallet_id: id
      });
      // console.log('response',response);
      if (response.data.success == '0') {
        // console.log('real data get',response.data.data)
        setAccountBalance(response.data.data.balance)
        setAccountEquity(response.data.data.equity)
        setRemainDailyLoss(response.data.data.remainDailyLoss)
        setRemainMaxLoss(response.data.data.remainOverAllLoss)
        setDailyMaxLossLimit(response.data.data.dailyLoss)
        setMaxOverallLossLimit(response.data.data.overAllLoss)
        setMakeOverAllLossPercentage(response.data.data.totalOverAllLossPercentage)
        setMakeDailyLossPercentage(response.data.data.totalDailyLossPercentage)
        setDailyMaxThreadShold(response.data.data.dailyThreadshold)
        setMaxOverallLossThreadShold(response.data.data.overAllThreadshold)
        setAccountStatus(response.data.data.accountStatus);
      }
      // setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const sendRealAccountRequest = async () => {
    try {
      setIsLoading(true);
      // console.log({id});
      setRequestSubmitSuccsess(false);

      const response = await apiCall(API_URL + 'send-real-account-request', {
        user_id: state.userData.id,
        token: token,
        user_wallet_id: id
      });
      if (response.data.success == '0') {
        setCheckRealAccountIsCreated(1);
        setRequestSubmitSuccsess(true);
        setRequestSubmitSuccessMsg('Your real account request has been sent');
        setIsLoading(false);
      } else {
        setIsLoading(false);

      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const sendPassedAccountRequest = async () => {
    try {
      setIsLoading(true);
      // console.log({id});
      setRequestSubmitSuccsess(false);

      const response = await apiCall(API_URL + 'send-passed-account-request', {
        user_id: state.userData.id,
        token: token,
        user_wallet_id: id
      });
      if (response.data.success == '0') {
        setCheckPassedAccountIsCreated(1);
        setRequestSubmitSuccsess(true);
        setRequestSubmitSuccessMsg('Your passed account request has been sent');
        setIsLoading(false);
      } else {
        setIsLoading(false);

      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleSendRealAccountRequest = () => {
    sendRealAccountRequest();
  }

  const handleSendPassedAccountRequest = () => {
    sendPassedAccountRequest();
  }

  useEffect(() => {
    if (applyForRealAccount == 1) {
      getTradDashboardDetails();
    }
  }, [applyForRealAccount]);

  // useEffect(() => {
  //   if (applyForRealAccount == 1) {
  //     getTradDashboardDetails();
  //   }
  // }, [applyForRealAccount]);


  // Calander Header section
  const calenderHeader = () => {
    return (
      <CalendarNavigation
        className="calender-header"
        prev={prevMonth}
        next={nextMonth}
        date={`${format(currentMonth, 'MMM')} ${format(currentMonth, 'yyyy')}`}
      />
    );
  };

  // Calander Days section 
  const calanderWeeks = () => {
    const days = [];
    const date = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    for (let i = 0; i < 7; i++) {
      days.push(
        <div className="cw-item" key={i}>{date[i]}</div>
      );
    }
    return <div className="calander-weeks">{days}</div>;
  };

  // Calander Days section
  const calanderCells = () => {
    const monthStart = startOfMonth(currentMonth);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfWeek(monthStart);
    const endDate = endOfWeek(monthEnd);
    const rows = [];

    let days = [];
    let day = startDate;
    let formattedDate = '';
    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        formattedDate = format(day, 'd');
        const dateString = format(day, 'yyyy-MM-dd');
        const dayData = dataForCalender.data[dateString] || { profit: 0, loss: 0 };
        const netAmount = (dayData.profit - dayData.loss) != 0 ? (dayData.profit - dayData.loss).toFixed(2) : 0;
        const eventClass = netAmount == 0 ? '' : netAmount < 0 ? 'cd-i-red' : 'cd-i-green';
        const eventSign = netAmount == 0 ? '$' : netAmount < 0 ? '-$' : '+$';
        const eventIcon = netAmount < 0 ? <ArrowLeftDownSvg /> : <ArrowRightUpSvg />;
        days.push(
          <div key={day} className={`cd-item ${!isSameMonth(day, monthStart) ? 'cd-i-disabled' : ''} ${isSameDay(day, selectedDate) ? 'cd-i-seleted' : ''} ${eventClass}`} onClick={netAmount != 0 ? () => onDateClick(dateString) : undefined}>
            <span className="cd-i-date">{formattedDate}</span>
            <span className="cd-i-event">{eventIcon} {`${eventSign + Math.abs(netAmount)}`}</span>
          </div>
        );
        day = addDays(day, 1);
      }
      rows.push(
        <div className="calander-days" key={day}>{days}</div>
      );
      days = [];
    }

    return rows;
  };

  const nextMonth = () => {
    setCurrentMonth(addMonths(currentMonth, 1));
    setChangeMonth(addMonths(currentMonth, 1));
  };

  const prevMonth = () => {
    setCurrentMonth(subMonths(currentMonth, 1));
    setChangeMonth(subMonths(currentMonth, 1));
  };

  const onDateClick = (day) => {
    console.log('selected day', day);
    setSelectedDate(day);
    setChangeSelectedDate(day);
  };

  useEffect(() => {
    getDataForAccountDetailsDateWise();
  }, [changeSelectedDate]);


  useEffect(() => {
    getDataForAccountDetailsCalender();
  }, [changeMonth]);

  const getUserProfile = async () => {
    // Logic to get user wallet group-wise data
    try {
      const response = await apiCall(API_URL + 'get-profile', {
        user_id: state.userData.id,
        token: token,
        nopaginate: 1,
      });
      if (response.data.success == '0') {
        // console.log(response.data.data);

        if (response.data.data.thumb_url) {
          setPhotoUrl(response.data.data.thumb_url);
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const downloadCertificate = async () => {
    try {
      // setIsLoading(true);
      // console.log({id});
      const response = await apiCall(API_URL + 'download-pdf', {
        user_id: state.userData.id,
        token: token,
        type: "account_details",
        user_wallet_id: id
      });
      if (response.data.success == '0') {
        // window.open(response.data.data.download_link);

        //   console.log(response);
        const link = document.createElement('a');
        link.href = response.data.data.download_link;
        link.setAttribute('target', '_blank'); // Open in a new tab

        // link.setAttribute('download', 'passed_certificate.pdf'); // Set default filename (optional)
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

      }
      // setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  return (
    <>
      {!dataLoaded && <Loaders />}

      {dataLoaded &&
        <>
          {/* <Breadcrumb className="" breadcrumbIcon="TradeSvg" breadcrumbHeading="Analytics" /> */}
          <div className="container-lg cl-custome3">
            <div className="row row-gap-4">

              {/* --- Passed or 2 step alert message --- */}
              {((accountStatus == 'passed' && userWalletParentID != '' && accountType == "2 step" && checkRealAccountIsRejected == 0) || (accountStatus == 'passed' && accountType == "1 step" && checkRealAccountIsRejected == 0) || (accountStatus == 'passed' && accountType == "HFT" && checkRealAccountIsRejected == 0)) &&
                <div className="col-12" id="RealAccountApply">
                  <div class="accoutn-alert-bx">
                    <div class="accoutn-inner">
                      <div class="ai-data">
                        <div className="ai-icon">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.6669 17.5H8.33358M1.91178 4.84992C1.89983 3.64046 2.5519 2.51104 3.60529 1.91667M18.0854 4.84992C18.0974 3.64046 17.4453 2.51105 16.3919 1.91667M15.0002 6.66667C15.0002 5.34059 14.4735 4.06882 13.5358 3.13114C12.5981 2.19346 11.3263 1.66667 10.0002 1.66667C8.67417 1.66667 7.4024 2.19346 6.46471 3.13114C5.52703 4.06882 5.00025 5.34059 5.00025 6.66667C5.00025 9.24183 4.35064 11.005 3.62497 12.1712C3.01285 13.1549 2.7068 13.6468 2.71802 13.784C2.73045 13.9359 2.76263 13.9938 2.88506 14.0847C2.99563 14.1667 3.49407 14.1667 4.49096 14.1667H15.5095C16.5064 14.1667 17.0049 14.1667 17.1154 14.0847C17.2379 13.9938 17.2701 13.9359 17.2825 13.784C17.2937 13.6468 16.9876 13.1549 16.3755 12.1712C15.6499 11.005 15.0002 9.24183 15.0002 6.66667Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </div>
                        <div>
                          <div class="ai-heading">Congratulations</div>
                          <div class="ai-text">{checkRealAccountIsCreated === 0 ? ("Congratulations your profit target has been achieved!  Now you can proceed to apply for real account.") : checkRealAccountIsApproved === 0 ? ("Your real account request is under review.") : ("Your real account details have been sent to your email.")}</div>
                        </div>
                      </div>
                      <div class="common-btn cb-outline" onClick={checkRealAccountIsCreated === 0 ? handleSendRealAccountRequest : undefined}><span>{checkRealAccountIsCreated === 0 ? "Apply Here" : undefined}</span></div>
                    </div>
                  </div>
                </div>
              }

              {((accountStatus == 'not_passed' && passedAccountRequest && accountType == "2 step" && checkPassedAccountIsRejected == 0)) &&
                <div className="col-12" id="RealAccountApply">
                  <div class="accoutn-alert-bx">
                    <div class="accoutn-inner">
                      <div class="ai-data">
                        <div className="ai-icon">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.6669 17.5H8.33358M1.91178 4.84992C1.89983 3.64046 2.5519 2.51104 3.60529 1.91667M18.0854 4.84992C18.0974 3.64046 17.4453 2.51105 16.3919 1.91667M15.0002 6.66667C15.0002 5.34059 14.4735 4.06882 13.5358 3.13114C12.5981 2.19346 11.3263 1.66667 10.0002 1.66667C8.67417 1.66667 7.4024 2.19346 6.46471 3.13114C5.52703 4.06882 5.00025 5.34059 5.00025 6.66667C5.00025 9.24183 4.35064 11.005 3.62497 12.1712C3.01285 13.1549 2.7068 13.6468 2.71802 13.784C2.73045 13.9359 2.76263 13.9938 2.88506 14.0847C2.99563 14.1667 3.49407 14.1667 4.49096 14.1667H15.5095C16.5064 14.1667 17.0049 14.1667 17.1154 14.0847C17.2379 13.9938 17.2701 13.9359 17.2825 13.784C17.2937 13.6468 16.9876 13.1549 16.3755 12.1712C15.6499 11.005 15.0002 9.24183 15.0002 6.66667Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </div>
                        <div>
                          <div class="ai-heading">Congratulations Congratulations profit target achieved</div>
                          <div class="ai-text">{checkPassedAccountIsCreated === 0 ? ("Congratulations your profit target has been achieved!  Now you can proceed to apply for phase 2 account.") : checkPassedAccountIsApproved === 0 ? ("Your account request is under review") : ("Your phase 2 account details have been sent to your email.")}</div>
                        </div>
                      </div>
                      <div class="common-btn cb-fill" onClick={checkPassedAccountIsCreated === 0 ? handleSendPassedAccountRequest : undefined}><span>{checkPassedAccountIsCreated === 0 ? "Apply Here" : undefined}</span></div>
                    </div>
                  </div>
                </div>
              }

              {/* --- Disabled alert message --- */}
              {(accountStatus == 'disabled') &&
                <div className="col-12">
                  <div class="accoutn-alert-bx">
                    <div class="accoutn-inner">
                      <div class="ai-data">
                        <div className="ai-icon">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.6669 17.5H8.33358M1.91178 4.84992C1.89983 3.64046 2.5519 2.51104 3.60529 1.91667M18.0854 4.84992C18.0974 3.64046 17.4453 2.51105 16.3919 1.91667M15.0002 6.66667C15.0002 5.34059 14.4735 4.06882 13.5358 3.13114C12.5981 2.19346 11.3263 1.66667 10.0002 1.66667C8.67417 1.66667 7.4024 2.19346 6.46471 3.13114C5.52703 4.06882 5.00025 5.34059 5.00025 6.66667C5.00025 9.24183 4.35064 11.005 3.62497 12.1712C3.01285 13.1549 2.7068 13.6468 2.71802 13.784C2.73045 13.9359 2.76263 13.9938 2.88506 14.0847C2.99563 14.1667 3.49407 14.1667 4.49096 14.1667H15.5095C16.5064 14.1667 17.0049 14.1667 17.1154 14.0847C17.2379 13.9938 17.2701 13.9359 17.2825 13.784C17.2937 13.6468 16.9876 13.1549 16.3755 12.1712C15.6499 11.005 15.0002 9.24183 15.0002 6.66667Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </div>
                        <div>
                          <div class="ai-heading">Violation Alert!</div>
                          <div class="ai-text">{drawDownReason}</div>
                        </div>
                      </div>
                      <div class="common-btn cb-outline" onClick={() => handleAnalysisModalShow('Loss')}><span>View Snapshot</span></div>
                    </div>
                  </div>
                </div>
              }


              {/* --- Next phase alert message --- */}
              <div className="col-12 d-none">
                <Alert
                  className="status-yellow2"
                  icon="NotificationsSvg"
                  heading="Next Phase"
                  text="Congratulations, you will receive your next phase account shortly. This is an automatic process"
                />
              </div>


              {/* --- Account Balance section --- */}
              <div className="col-12">
                <div className="common-box">

                  <div className="d-flex flex-column flex-sm-row justify-content-between">
                    <div className="common-box-heading cbh-flex">
                      <div className="cbh-icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15.8882 7.06367C14.9477 7.11343 14.3519 7.63403 14.3458 8.56722C14.3276 11.6374 14.3276 14.7076 14.3446 17.7778C14.3495 18.6673 15.0048 19.2838 15.8846 19.3154C16.086 19.3226 16.2887 19.3275 16.4901 19.3251C17.8129 19.3056 18.3699 18.7571 18.3771 17.4477C18.3844 16.034 18.3784 14.6203 18.3784 13.2065C18.3796 13.2065 18.3796 13.2065 18.3808 13.2065C18.3808 11.9748 18.3407 10.7406 18.3893 9.51012C18.473 7.38889 17.8699 6.9581 15.8882 7.06367Z" fill="#35F8F8" />
                          <path d="M3.58307 10.5855C7.86072 9.12202 11.8847 7.1816 15.3894 4.26795C15.5447 4.13931 15.6479 3.90996 15.9039 3.91603C15.9233 4.81524 16.2146 5.23512 16.808 5.23269C17.416 5.22905 17.7278 4.76913 17.7291 3.8687C17.7303 3.24252 17.7303 2.61635 17.7291 1.99139C17.7254 0.969603 17.4439 0.679572 16.4464 0.675931C15.8202 0.673504 15.1952 0.674718 14.569 0.675931C13.6359 0.677145 13.1917 0.956254 13.1674 1.55573C13.1432 2.16128 13.5412 2.45495 14.6212 2.5314C13.2293 3.71094 11.8508 4.67933 10.3897 5.53365C8.05245 6.89886 5.58173 7.96068 3.03213 8.85505C2.37804 9.0844 2.12927 9.5152 2.31008 10.0346C2.49697 10.5649 2.97267 10.793 3.58307 10.5855Z" fill="#35F8F8" />
                          <path d="M12.0412 12.0802C12.0315 10.8109 11.4527 10.2369 10.1918 10.2344C10.0098 10.2344 9.82899 10.232 9.64697 10.2344C8.59242 10.2466 7.9626 10.8145 7.94804 11.8581C7.92256 13.7937 7.92377 15.7305 7.94683 17.666C7.95896 18.6745 8.61305 19.28 9.63726 19.3104C9.8387 19.3164 10.0401 19.3201 10.2416 19.314C11.4515 19.2764 12.0315 18.6842 12.0412 17.4658C12.0485 16.5581 12.0425 15.6504 12.0425 14.7427C12.0425 13.8544 12.0485 12.9673 12.0412 12.0802Z" fill="#35F8F8" />
                          <path d="M3.0819 12.5259C2.21909 12.5695 1.65116 13.1083 1.61597 13.9784C1.59049 14.6034 1.61112 15.2296 1.61112 15.8557C1.61233 16.522 1.58685 17.1894 1.6184 17.8544C1.65723 18.6711 2.29918 19.2803 3.10981 19.3143C3.41198 19.3264 3.71536 19.324 4.01752 19.3167C5.00897 19.2924 5.62422 18.6808 5.64243 17.6772C5.6582 16.7889 5.61573 15.8994 5.65699 15.0124C5.76256 12.6957 5.02838 12.4263 3.0819 12.5259Z" fill="#35F8F8" />
                        </svg>
                      </div>
                      Analytics
                    </div>

                    <div className="d-flex justify-content-end flex-wrap cbi-gap-10px">
                      <div className="common-btn cb-outline" onClick={() => handleAnalysisModalShow('Account analysis')}><span><Icons.BarSvg />Analysis</span></div>
                      <div className="common-btn cb-fill" onClick={() => handleCredentialsModalShow(id)}><span><Icons.Key2Svg />Credentials</span></div>
                      {(accountStatus == 'passed' && showCertificate == 1) &&
                        <div className="common-btn cb-white-fill" onClick={() => downloadCertificate()}><span><Icons.AcademicCapSvg />Certificate</span></div>
                      }
                    </div>
                  </div>

                  <div className="row my-4 row-gap-4">
                    <div className="col-xl-4">
                      <div className="common-box cb-color3 cb-100-percent">
                        <div className="account-info-bx">
                          <div>
                            <div className="d-flex justify-content-between align-items-center">

                            <div class="aib-account-label">Account</div>
                            <AccountStatus
                              
                              className={(accountStatus == 'not_passed') ? 'status-red2' : (accountStatus == 'refunded' ? 'status-yellow2' : (accountStatus == 'disabled' ? 'status-yellow2' : (accountStatus == 'passed' ? 'status-green2' : 'status-green2')))}
                              statusText={formatStatus(accountStatus)}
                              />
                              </div>
                            <div className="aib-inner-bx">
                              <div className="aib-i-img">
                                {/* <img src={accountStatus == 'real' ? practitioner : student} alt="" /> */}
                                <img src={photoUrl || student} />
                              </div>
                              <div className="aib-i-data">
                                <div className="aib-i-name">MT5 {accountNumber}
                                  
                                </div>
                                <div className="aib-i-created">Created At: {anotherFormatDate(createDate)}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <LimitCardItem
                      className="col-xl-4 col-sm-6"
                      className2="cb-color3"
                      chartType="line"
                      heading="Min Trading Days"
                      leftAmount={countMaxTradingDaysLeft + " Day(s)"}
                      leftText="Left"
                      percent={countMaxTradingDaysLeftPercentage != 0 ? countMaxTradingDaysLeftPercentage.toFixed(2) : 0}
                      minTradingDay={maxTradingDays}
                    />

                    <LimitCardItem
                      className="col-xl-4 col-sm-6"
                      className2="cb-color3"
                      chartType="line"
                      heading="Max Loss Limit"
                      leftAmount={"$" + (remainMaxLoss > 0 ? remainMaxLoss.toFixed(2) : 0)}
                      leftText="Left"
                      percent={makeOverAllLossPercentage != 0 ? makeOverAllLossPercentage.toFixed(2) : 0}
                      maxLoss={"$" + (maxOverallLossLimit > 0 ? maxOverallLossLimit.toFixed(2) : 0)}
                      threshold={"$" + (maxOverallLossThreadShold > 0 ? maxOverallLossThreadShold.toFixed(2) : 0)}
                    />
                  </div>

                  <div class="to-alert-bx ">
                    <div class="to-data">
                      <div className="to-icon">
                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18.3037 4.25514C18.3037 4.25514 18.4504 2.76787 18.0913 2.40875M18.0913 2.40875C17.73 2.04751 16.2451 2.1976 16.2451 2.1976M18.0913 2.40875L15.8333 4.66666" stroke="#060606" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M18.3037 16.7448C18.3037 16.7448 18.4504 18.2321 18.0913 18.5912M18.0913 18.5912C17.73 18.9525 16.2451 18.8024 16.2451 18.8024M18.0913 18.5912L15.8333 16.3333" stroke="#060606" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M1.90872 2.40874L4.16665 4.66666M1.90872 2.40874C2.26996 2.04751 3.75493 2.1976 3.75493 2.1976M1.90872 2.40874C1.5496 2.76787 1.69633 4.25514 1.69633 4.25514" stroke="#060606" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M1.90872 18.5912L4.16665 16.3333M1.90872 18.5912C2.26996 18.9525 3.75493 18.8024 3.75493 18.8024M1.90872 18.5912C1.5496 18.2321 1.69633 16.7449 1.69633 16.7449" stroke="#060606" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M15.8333 10.5C15.8333 13.7217 13.2217 16.3334 9.99999 16.3334C6.77833 16.3334 4.16666 13.7217 4.16666 10.5C4.16666 7.27836 6.77833 4.66669 9.99999 4.66669C13.2217 4.66669 15.8333 7.27836 15.8333 10.5Z" stroke="#060606" stroke-width="1.25" />
                          <path d="M9.92834 8.25108C9.00784 8.25108 8.33334 8.7862 8.33334 9.40727C8.33334 10.0283 8.76826 10.4166 10 10.4166C11.3568 10.4166 11.6667 11.0353 11.6667 11.6563C11.6667 12.2774 11.0736 12.7679 9.92834 12.7679M9.92834 8.25108C10.654 8.25108 11.0376 8.50513 11.3405 8.8471M9.92834 8.25108V7.54755M9.92834 12.7679C9.20268 12.7679 8.92051 12.6245 8.52084 12.2629M9.92834 12.7679V13.424" stroke="#060606" stroke-width="1.25" stroke-linecap="round" />
                        </svg>
                      </div>
                      <div>
                        <div class="to-heading">Trading objectives</div>
                        <div class="to-text">Please note: Hitting either the daily loss limit or the maximum loss limit will result in a permanent account breach.</div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <Alert
                  className="alert-style3 common-box"
                  icon="AffiliateSvg"
                  heading="Trading objectives"
                  text="Please note: Hitting either the daily loss limit or the maximum loss limit will result in a permanent account breach."
                /> */}
              </div>

              <div className="col-lg-4">
                <div className="common-box cb-100-percent">
                  <div className="common-box-heading cbh-flex">
                    <div className="cbh-icon">

                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 2.83339C1.25 2.37316 1.6231 2.00006 2.08333 2.00006H17.9167C18.3769 2.00006 18.75 2.37316 18.75 2.83339C18.75 3.29363 18.3769 3.66673 17.9167 3.66673H2.08333C1.6231 3.66673 1.25 3.29363 1.25 2.83339Z" fill="#35F8F8" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.125 2.83344C3.125 2.48826 3.40482 2.20844 3.75 2.20844L16.25 2.20844C16.5952 2.20844 16.875 2.48826 16.875 2.83344V11.9993C16.875 12.9894 16.7884 13.7725 16.4065 14.447C16.0245 15.1216 15.3976 15.5987 14.5486 16.1081L12.0107 17.6308L12.0107 17.6309C11.6149 17.8684 11.2786 18.0702 10.9832 18.2091C10.6686 18.357 10.355 18.4564 10 18.4564C9.64503 18.4564 9.33144 18.357 9.01682 18.209C8.72138 18.0702 8.38501 17.8683 7.98914 17.6308L7.96481 17.6162L7.96345 17.6154L5.45137 16.1081C4.60239 15.5987 3.97547 15.1216 3.59355 14.447C3.21162 13.7725 3.125 12.9894 3.125 11.9993L3.125 2.83344ZM7.91667 6.16677C7.45643 6.16677 7.08333 6.53986 7.08333 7.0001C7.08333 7.46034 7.45643 7.83344 7.91667 7.83344L12.0833 7.83344C12.5436 7.83344 12.9167 7.46034 12.9167 7.0001C12.9167 6.53986 12.5436 6.16677 12.0833 6.16677H7.91667ZM7.91667 10.3334C7.45643 10.3334 7.08333 10.7065 7.08333 11.1668C7.08333 11.627 7.45643 12.0001 7.91667 12.0001H12.0833C12.5436 12.0001 12.9167 11.627 12.9167 11.1668C12.9167 10.7065 12.5436 10.3334 12.0833 10.3334H7.91667Z" fill="#35F8F8" />
                      </svg>

                    </div>
                    Overview
                  </div>

                  <div className="account-basic-info">
                    <div className="abi-item">
                      <div className="abi-label">Platform</div>
                      <div className="abi-data"><span>Metatrader 5</span></div>
                    </div>
                    <div className="abi-item">
                      <div className="abi-label">Account Type</div>
                      <div className="abi-data"><span>{accountType}</span></div>
                    </div>
                    <div className="abi-item">
                      <div className="abi-label">Phase</div>
                      <div className="abi-data">{accountPhase}</div>
                    </div>
                    <div className="abi-item">
                      <div className="abi-label">Account Size</div>
                      <div className="abi-data abi-highlight">${accountSize}.00</div>
                    </div>
                    <div className="abi-item">
                      <div className="abi-label">Start Trade Period</div>
                      <div className="abi-data">{anotherFormatDate(startTradePeriod) != 'Invalid Date' ? anotherFormatDate(startTradePeriod) : ''}</div>
                    </div>
                    <div className="abi-item">
                      <div className="abi-label">End Trade Period</div>
                      <div className="abi-data">{anotherFormatDate(endTradePeriod) != 'Invalid Date' ? anotherFormatDate(endTradePeriod) : ''}</div>
                    </div>
                  </div>

                </div>
              </div>

              {(mt5Type != 'real') &&
                <LimitCardItem
                  className="col-lg-4 col-sm-6 profit-target-bx"
                  heading="Profit Target"
                  leftAmount={"$" + (remainMaxProfit > 0 ? remainMaxProfit.toFixed(2) : 0)}
                  leftText="Left"
                  percent={makeOverAllProfitPercentage != 0 ? makeOverAllProfitPercentage.toFixed(2) : makeOverAllProfitPercentage}
                  profitTarget={"$" + (profitTarget > 0 ? profitTarget.toFixed(2) : 0)}
                />
              }

              <LimitCardItem
                className="col-lg-4 col-sm-6"
                chartType="halfarc"
                heading="Daily Loss Limit"
                lcTime={timeLeft.hours + ":" + timeLeft.minutes + ":" + timeLeft.seconds}
                leftAmount={"$" + (remainDailyLoss > 0 ? remainDailyLoss.toFixed(2) : 0)}
                leftText="Left"
                percent={makeDailyLossPercentage != 0 ? makeDailyLossPercentage.toFixed(2) : 0}
                maxDailyLoss={"$" + (dailyMaxLossLimit > 0 ? dailyMaxLossLimit.toFixed(2) : 0)}
                balance={"$" + accountBalance}
                threshold={"$" + (dailyMaxThreadShold > 0 ? dailyMaxThreadShold.toFixed(2) : 0)}
              />

              <div className="col-12">
                <div className="common-box">
                  <div className="dwmy-filter-bx">
                    <div className="common-box-heading cbh-flex mb-0">
                      <div className="cbh-icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2795 1.10767C10.1035 1.01969 9.89644 1.01969 9.72048 1.10767L1.38715 5.27434C1.17541 5.38021 1.04166 5.59662 1.04166 5.83335V8.12502H18.9583V5.83335C18.9583 5.59662 18.8246 5.38021 18.6128 5.27434L10.2795 1.10767ZM10.8335 5.00006H9.16682V6.66673H10.8335V5.00006Z" fill="#35F8F8" />
                          <path d="M1.04224 16.2501C1.04224 15.9049 1.32206 15.6251 1.66724 15.6251H18.3339C18.4997 15.6251 18.6587 15.6909 18.7759 15.8081C18.8931 15.9254 18.9589 16.0843 18.9589 16.2501L18.9586 18.3335C18.9586 18.6786 18.6788 18.9584 18.3336 18.9584H1.66724C1.32206 18.9584 1.04224 18.6786 1.04224 18.3334V16.2501Z" fill="#35F8F8" />
                          <path d="M17.2918 9.37506H12.7085V14.3751H17.2918V9.37506Z" fill="#35F8F8" />
                          <path d="M7.29183 9.37506H2.7085V14.3751H7.29183V9.37506Z" fill="#35F8F8" />
                        </svg>
                      </div>
                      Account Overview
                    </div>

                    <div className="signinup-group sg-aof-bx sab-dwmy-filter mb-0">
                      {/* <div className="sg-list-bx">
                            <div className="sg-list-item active">Daily</div>
                            <div className="sg-list-item">Weekly</div>
                            <div className="sg-list-item">Monthly</div>
                            <div className="sg-list-item">Yearly</div>
                        </div> */}
                      {/* <div className="sg-list-bx border-0">
                        {options.map((option) => (
                          <div
                            key={option}
                            className={`sg-list-item ${selectedOption === option ? 'active' : ''}`}
                            onClick={() => handleOptionChange(option)}
                          >
                            {option.charAt(0).toUpperCase() + option.slice(1)}
                          </div>
                        ))}
                      </div> */}
                      <DropItem 
                        className='ci-tf-capitalize'
                        options={options}
                        selectedOption={selectedOption}
                        onChange={handleOptionChange}
                      />
                    </div>
                  </div>

                  <div className="common-box overflowhidden common-box-light">



                    <div className="signinup-group sg-aof-bx sab-lb-filter">
                      <div className="sg-list-bx border-0">
                        <div className={`sg-list-item ${chartType === 'line' ? 'active' : ''}`} onClick={() => setChartType('line')}>Line Chart</div>
                        <div className={`sg-list-item ${chartType === 'bar' ? 'active' : ''}`} onClick={() => setChartType('bar')}>Bar Chart</div>
                      </div>
                    </div>

                    {/* <DropItem 
                      className='ci-tf-capitalize d-none'
                      options={options}
                      selectedOption={selectedOption}
                      onChange={handleOptionChange}
                    /> */}

                    <div className="aoi-outer">
                      <div className="account-overview-item">
                        <div className="aoi-label">Account balance</div>
                        <div className="aoi-data">${accountBalance}</div>
                      </div>

                      <div className="account-overview-item">
                        <div className="aoi-label">Equity:</div>
                        <div className="aoi-data">${accountEquity}</div>
                      </div>

                      <div className="account-overview-item">
                        <div className="aoi-label">Profit:</div>
                        <div className="aoi-data status-neon-green">{totalProfit != 0 && accountBalance > 0 ? parseFloat((totalProfit / accountSize) * 100).toFixed(2) : 0}%</div>
                      </div>
                    </div>

                    <AccountChart profitChartData={profitChartData} chartType={chartType} filterValue={selectedOption} />

                  </div>
                  <div className="aoi-outer aoi-style-2 mt-4">
                    <div className="aoi-inner">
                      <div className="account-overview-item">
                        <div className="aoi-label">Average win</div>
                        <div className="aoi-data">${avgWin > 0 ? parseFloat(avgWin).toFixed(2) : 0}<span className='aoi-status-green'>+10.9%</span></div>
                      </div>
                    </div>

                    <div className="aoi-inner">
                      <div className="account-overview-item">
                        <div className="aoi-label">Average loss</div>
                        <div className="aoi-data">${avgLoss > 0 ? parseFloat(avgLoss).toFixed(2) : 0}<span className='aoi-status-red'>-3.9%</span></div>
                      </div>
                    </div>

                    <div className="aoi-inner">
                      <div className="account-overview-item">
                        <div className="aoi-label">Win ratio</div>
                        <div className="aoi-data">{winRatio > 0 ? winRatio.toFixed(2) : 0}%</div>
                      </div>
                    </div>

                    <div className="aoi-inner">
                      <div className="account-overview-item">
                        <div className="aoi-label">Profit Factor</div>
                        <div className="aoi-data">{totalProfit > 0 && totalLoss != 0 ? (totalProfit / totalLoss).toFixed(2) : 0}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="calender-bx-outer">
                  <div className="common-box cbo-left">
                    <div className="common-box-heading cbh-16small">{format(selectedDate, 'EEE dd MMM')} Summary</div>
                    <div className="aoi-outer aoi-style-2">

                      <div className="aoi-inner">
                        <div className="account-overview-item">
                          <div className="aoi-label">Ending balance</div>
                          <div className="aoi-data">${endingBalanceSelectedDay}</div>
                        </div>
                      </div>

                      <div className="aoi-inner">
                        <div className="account-overview-item">
                          <div className="aoi-label">Trades taken</div>
                          <div className="aoi-data">{tradeTakenSelectedDay}</div>
                        </div>
                      </div>

                      <div className="aoi-inner">
                        <div className="account-overview-item" title={usedLotsSelectedDay}>
                          <div className="aoi-label">Lots used</div>
                          <div className="aoi-data aoi-limit">{usedLotsSelectedDay}</div>
                        </div>
                      </div>

                      <div className="aoi-inner">
                        <div className="account-overview-item">
                          <div className="aoi-label">Profit</div>
                          <div className={`aoi-data ${amountSelectedDay === 0 ? "" : amountSelectedDay < 0 ? "status-red" : "status-green"}`}>{amountSelectedDay != 0 ? (amountSelectedDay > 0) ? '+$' + Math.abs(amountSelectedDay).toFixed(2) : '-$' + Math.abs(amountSelectedDay).toFixed(2) : '$0'}</div>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div className="common-box cbo-right">
                    <div className="common-box-heading" style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                      <div className="cbh-icon cbh-icon-light cbh-icon-light-calender">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 1.66666V3.33332M5 1.66666V3.33332" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9.99755 10.833H10.0051M9.99755 14.1663H10.0051M13.3271 10.833H13.3346M6.66797 10.833H6.67544M6.66797 14.1663H6.67544" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.91797 6.6665H17.0846" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.08203 10.2027C2.08203 6.57162 2.08203 4.75607 3.12546 3.62803C4.1689 2.5 5.84827 2.5 9.20703 2.5H10.7904C14.1491 2.5 15.8285 2.5 16.8719 3.62803C17.9154 4.75607 17.9154 6.57162 17.9154 10.2027V10.6307C17.9154 14.2617 17.9154 16.0773 16.8719 17.2053C15.8285 18.3333 14.1491 18.3333 10.7904 18.3333H9.20703C5.84827 18.3333 4.1689 18.3333 3.12546 17.2053C2.08203 16.0773 2.08203 14.2617 2.08203 10.6307V10.2027Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.5 6.66666H17.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                      </div>
                      Calender
                    </div>
                    <div className="calender-bx">
                      {calenderHeader()}
                      {calanderWeeks()}
                      {dataForCalender && calanderCells !== null && calanderCells()}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="common-box">
                  <div className="row row-gap-3">
                    <ScaleOverviewItem
                      icon={<Ewallets2Svg />}
                      heading="Balance Overview"
                      min={"$" + minBalance != null ? minBalance : 0}
                      max={"$" + maxBalance != null ? maxBalance : 0}
                      percent={(minBalance > 0 && maxBalance > 0) ? 100 * (accountBalance - minBalance) / (maxBalance - minBalance) : 0}
                      current={"$" + accountBalance}
                    />

                    <ScaleOverviewItem
                      icon={<Equity2Svg />}
                      heading="Equity Overview"
                      min={"$" + minEquity != null ? minEquity : 0}
                      max={"$" + maxEquity != null ? maxEquity : 0}
                      percent={(minEquity > 0 && maxEquity > 0) ? 100 * (accountEquity - minEquity) / (maxEquity - minEquity) : 0}
                      current={"$" + accountEquity}
                    />
                  </div>
                </div>
              </div>




              {/* --- Daily Summary section --- */}
              <div className="col-12">
                <div className="common-box">

                  <div className="common-box-heading cbh-small">Daily Summary</div>

                  <div className="table-responsive custom-table-responsive">
                    <table className="custom-table">
                      <thead>
                        <tr>
                          <th>Sr.</th>
                          <th onClick={() => handleSort('close_date')}
                            className={sortField === 'close_date' ? (sortDirection === 'asc' ? 'asc active' : 'desc active') : ''}>Date<SortIcons />
                            <div className="th-sort-icons">
                              <div
                                className={sortField === 'close_date' && sortDirection === 'asc' ? 'asc' : ''}
                              />
                              <div
                                className={sortField === 'close_date' && sortDirection === 'desc' ? 'desc' : ''}
                              />
                            </div>
                          </th>
                          <th onClick={() => handleSort('total_trade')} className={sortField === 'total_trade' ? (sortDirection === 'asc' ? 'asc active' : 'desc active') : ''}>Trades<SortIcons />
                            <div className="th-sort-icons">
                              <div
                                className={sortField === 'total_trade' && sortDirection === 'asc' ? 'asc' : ''}
                              />
                              <div
                                className={sortField === 'total_trade' && sortDirection === 'desc' ? 'desc' : ''}
                              />
                            </div>
                          </th>
                          <th onClick={() => handleSort('lots')} className={sortField === 'lots' ? (sortDirection === 'asc' ? 'asc active' : 'desc active') : ''}>Lots<SortIcons />
                            <div className="th-sort-icons">
                              <div
                                className={sortField === 'lots' && sortDirection === 'asc' ? 'asc' : ''}
                              />
                              <div
                                className={sortField === 'lots' && sortDirection === 'desc' ? 'desc' : ''}
                              />
                            </div>
                          </th>
                          <th onClick={() => handleSort('profit')} className={sortField === 'profit' ? (sortDirection === 'asc' ? 'asc active' : 'desc active') : ''}>Result<SortIcons />
                            <div className="th-sort-icons">
                              <div
                                className={sortField === 'profit' && sortDirection === 'asc' ? 'asc' : ''}
                              />
                              <div
                                className={sortField === 'profit' && sortDirection === 'desc' ? 'desc' : ''}
                              />
                            </div>
                          </th>
                          {/* <th>Date<SortIcons /></th>
                          <th>Trades<SortIcons /></th>
                          <th>Lots<SortIcons /></th>
                          <th>Result<SortIcons /></th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {(dailySummaryTradingList && dailySummaryTradingList.length > 0 && !isLoading) &&
                          dailySummaryTradingList.map((dailySummaryData, index) => (
                            <tr key={index}>
                              <td>{++index}</td>
                              <td>{anotherFormatDate(dailySummaryData.date_formatted)}</td>
                              <td>{dailySummaryData.total_trade}</td>
                              <td>{dailySummaryData.lots}</td>
                              <td>
                                {
                                  (dailySummaryData.profit - dailySummaryData.loss) > 0 ? (
                                    <span className="td-status status-green">+${(dailySummaryData.profit - dailySummaryData.loss).toFixed(2)}</span>
                                  ) : (dailySummaryData.profit - dailySummaryData.loss) < 0 ? (
                                    <span className="td-status status-red">-${(dailySummaryData.loss - dailySummaryData.profit).toFixed(2)}</span>
                                  ) : (
                                    <span>$0</span>
                                  )
                                }
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>
                  {(isLoading) && (
                    <div className="table-skeletant-bx">
                      <div className="skeletant-bx skeletant-design sh-49"></div>
                      <div className="skeletant-bx skeletant-design sh-49"></div>
                      <div className="skeletant-bx skeletant-design sh-49"></div>
                      <div className="skeletant-bx skeletant-design sh-49"></div>
                      <div className="skeletant-bx skeletant-design sh-49"></div>
                    </div>
                  )}

                  <div className="empty-box">
                    {(dailySummaryTradingList.length <= 0) &&
                      <EmptyBox className="empty-div-bx" eh="Data is not found" esh="Try adjusting filters to get results." />
                    }
                  </div>

                  {(dailySummaryTradingList && dailySummaryTradingList.length > 0 && !isLoading) &&
                    <Pagination
                      currentPage={pageDailySummary}
                      totalPages={totalPagesDailySummary}
                      onPageChange={onChangePageDailySummary}
                      prev={changePrevPageDailySummary}
                      next={changeNextPageDailySummary}
                    />
                  }

                </div>
              </div>


              {/* --- Open Positions section --- */}
              {/* <div className="col-12 d-none">
                <div className="common-box">
                  <div className="common-box-heading cbh-small">Open Positions</div>

                  <div className="table-responsive custom-table-responsive">
                    <table className="custom-table">
                      <thead>
                        <tr>
                          <th>Sr.<SortIcons /></th>
                          <th>Trade ID<SortIcons /></th>
                          <th>Symbol<SortIcons /></th>
                          <th>Type<SortIcons /></th>
                          <th>Entry Date<SortIcons /></th>
                          <th>Entry<SortIcons /></th>
                          <th>Tp<SortIcons /></th>
                          <th>Sl<SortIcons /></th>
                          <th>Lots<SortIcons /></th>
                          <th>Swap<SortIcons /></th>
                          <th>Profit<SortIcons /></th>
                        </tr>
                      </thead>
                      {!isLoading && <tbody>
                        {(openTradingList && openTradingList.length > 0 && !isLoading) &&
                          openTradingList.map((openTrading, index) => (
                            <tr key={index}>
                              <td>{++index}</td>
                              <td className="status-white">{openTrading.trade_id}</td>
                              <td>{(openTrading.symbol) ? openTrading.symbol.name : '-'}</td>
                              <td>{openTrading.side == 'buy' ? (
                                <span className="td-status status-green4">Buy</span>
                              ) : (
                                <span className="td-status status-red3">Sell</span>
                              )}</td>
                              <td>{anotherFormatDate(openTrading.open_date)}</td>
                              <td>{openTrading.open_price}</td>
                              <td>{openTrading.take_profit != '' ? openTrading.take_profit : '-'}</td>
                              <td>{openTrading.stop_loss != '' ? openTrading.stop_loss : '-'}</td>
                              <td>{openTrading.lots}</td>
                              <td>{openTrading.swap}</td>
                              <td>
                                {<span className="td-status status-red">{openTrading.profit > 0 ? "+$" + openTrading.profit : "$" + 0}</span>}
                              </td>
                            </tr>
                          ))
                        }


                      </tbody>

                      }
                    </table>

                  </div>
                  <div className="empty-box">
                    {(openTradingList.length <= 0) &&
                      <EmptyBox className="empty-div-bx" eh="Data is not found" esh="Try adjusting filters to get results." />
                    }
                  </div>

                  <div className="pagenation-filter d-none">
                    <div className="pf-left">
                      <div className="pf-label">Go to</div>
                      <div className="pf-input">
                        <input type="number" placeholder="Page" value={goPageOpenTrading} onChange={onChangePageOpenTrading} />
                      </div>
                    </div>
                    <div className="pf-right">
                      <div className="pf-pagination">
                        <div className="pf-btn" onClick={changePrevPageOpenTrading}>Prev</div>
                        <div className="pf-text">
                          <div>{pageOpenTrading}</div>
                          <span>/</span>
                          <div>{totalPagesOpenTrading}</div>
                        </div>
                        <div className="pf-btn pb-right" onClick={changeNextPageOpenTrading}>Next</div>
                      </div>
                    </div>
                  </div>

                  {(openTradingList && openTradingList.length > 0 && !isLoading) &&
                    <Pagination
                      currentPage={pageOpenTrading}
                      totalPages={totalPagesOpenTrading}
                      onPageChange={onChangePageTradingHistory}
                      prev={changePrevPageOpenTrading}
                      next={changeNextPageOpenTrading}
                    />
                  }

                </div>
              </div> */}



              {/* --- Trading History section start --- */}
              <div className="col-12">
                <div className="common-box">
                  <div className="common-box-heading cbh-small">Trading History</div>

                  <div className="table-responsive custom-table-responsive">
                    <table className="custom-table">
                      <thead>
                        <tr>
                          <th>Sr.</th>
                          <th onClick={() => handleSortone('trade_id')} className={sortFieldone === 'trade_id' ? (sortDirectionone === 'asc' ? 'asc active' : 'desc active') : ''}>
                            Trade ID<SortIcons />
                            <div className="th-sort-icons">
                              <div
                                className={sortFieldone === 'trade_id' && sortDirectionone === 'asc' ? 'asc' : ''}
                              />
                              <div
                                className={sortFieldone === 'trade_id' && sortDirectionone === 'desc' ? 'desc' : ''}
                              />
                            </div>
                          </th>

                          <th onClick={() => handleSortone('symbol')} className={sortFieldone === 'symbol' ? (sortDirectionone === 'asc' ? 'asc active' : 'desc active') : ''}>
                            Symbol<SortIcons />

                          </th>

                          <th onClick={() => handleSortone('type')} className={sortFieldone === 'type' ? (sortDirectionone === 'asc' ? 'asc active' : 'desc active') : ''}>
                            Type
                            <div className="th-sort-icons">
                              <div
                                className={sortFieldone === 'type' && sortDirectionone === 'asc' ? 'asc' : ''}
                              />
                              <div
                                className={sortFieldone === 'type' && sortDirectionone === 'desc' ? 'desc' : ''}
                              />
                            </div>
                          </th>

                          <th onClick={() => handleSortone('open_date')} className={sortFieldone === 'open_date' ? (sortDirectionone === 'asc' ? 'asc active' : 'desc active') : ''}>
                            Open Date<SortIcons />
                            <div className="th-sort-icons">
                              <div
                                className={sortFieldone === 'open_date' && sortDirectionone === 'asc' ? 'asc' : ''}
                              />
                              <div
                                className={sortFieldone === 'open_date' && sortDirectionone === 'desc' ? 'desc' : ''}
                              />
                            </div>
                          </th>

                          <th onClick={() => handleSortone('open')} className={sortFieldone === 'open' ? (sortDirectionone === 'asc' ? 'asc active' : 'desc active') : ''}>
                            Open<SortIcons />
                            <div className="th-sort-icons">
                              <div
                                className={sortFieldone === 'open' && sortDirectionone === 'asc' ? 'asc' : ''}
                              />
                              <div
                                className={sortFieldone === 'open' && sortDirectionone === 'desc' ? 'desc' : ''}
                              />
                            </div>
                          </th>

                          <th onClick={() => handleSortone('close_date')} className={sortFieldone === 'close_date' ? (sortDirectionone === 'asc' ? 'asc active' : 'desc active') : ''}>
                            Closed Date<SortIcons />
                            <div className="th-sort-icons">
                              <div
                                className={sortFieldone === 'close_date' && sortDirectionone === 'asc' ? 'asc' : ''}
                              />
                              <div
                                className={sortFieldone === 'close_date' && sortDirectionone === 'desc' ? 'desc' : ''}
                              />
                            </div>
                          </th>

                          <th onClick={() => handleSortone('close')} className={sortFieldone === 'close' ? (sortDirectionone === 'asc' ? 'asc active' : 'desc active') : ''}>
                            Close<SortIcons />
                            <div className="th-sort-icons">
                              <div
                                className={sortFieldone === 'close' && sortDirectionone === 'asc' ? 'asc' : ''}
                              />
                              <div
                                className={sortFieldone === 'close' && sortDirectionone === 'desc' ? 'desc' : ''}
                              />
                            </div>
                          </th>

                          <th onClick={() => handleSortone('tp')} className={sortFieldone === 'tp' ? (sortDirectionone === 'asc' ? 'asc active' : 'desc active') : ''}>
                            Tp<SortIcons />
                            <div className="th-sort-icons">
                              <div
                                className={sortFieldone === 'tp' && sortDirectionone === 'asc' ? 'asc' : ''}
                              />
                              <div
                                className={sortFieldone === 'tp' && sortDirectionone === 'desc' ? 'desc' : ''}
                              />
                            </div>
                          </th>

                          <th onClick={() => handleSortone('sl')} className={sortFieldone === 'sl' ? (sortDirectionone === 'asc' ? 'asc active' : 'desc active') : ''}>
                            Sl<SortIcons />
                            <div className="th-sort-icons">
                              <div
                                className={sortFieldone === 'sl' && sortDirectionone === 'asc' ? 'asc' : ''}
                              />
                              <div
                                className={sortFieldone === 'sl' && sortDirectionone === 'desc' ? 'desc' : ''}
                              />
                            </div>
                          </th>

                          <th onClick={() => handleSortone('lots')} className={sortFieldone === 'lots' ? (sortDirectionone === 'asc' ? 'asc active' : 'desc active') : ''}>
                            Lots<SortIcons />
                            <div className="th-sort-icons">
                              <div
                                className={sortFieldone === 'lots' && sortDirectionone === 'asc' ? 'asc' : ''}
                              />
                              <div
                                className={sortFieldone === 'lots' && sortDirectionone === 'desc' ? 'desc' : ''}
                              />
                            </div>
                          </th>

                          <th onClick={() => handleSortone('commission')} className={sortFieldone === 'commission' ? (sortDirectionone === 'asc' ? 'asc active' : 'desc active') : ''}>
                            Commission<SortIcons />
                            <div className="th-sort-icons">
                              <div
                                className={sortFieldone === 'commission' && sortDirectionone === 'asc' ? 'asc' : ''}
                              />
                              <div
                                className={sortFieldone === 'commission' && sortDirectionone === 'desc' ? 'desc' : ''}
                              />
                            </div>
                          </th>

                          <th onClick={() => handleSortone('profit')} className={sortFieldone === 'profit' ? (sortDirectionone === 'asc' ? 'asc active' : 'desc active') : ''}>
                            Profit<SortIcons />
                            <div className="th-sort-icons">
                              <div
                                className={sortFieldone === 'profit' && sortDirectionone === 'asc' ? 'asc' : ''}
                              />
                              <div
                                className={sortFieldone === 'profit' && sortDirectionone === 'desc' ? 'desc' : ''}
                              />
                            </div>
                          </th>
                          {/* <th>Trade ID<SortIcons /></th>
                          <th>Symbol<SortIcons /></th>
                          <th>Type<SortIcons /></th>
                          <th>Open Date<SortIcons /></th>
                          <th>Open<SortIcons /></th>
                          <th>Closed Date<SortIcons /></th>
                          <th>Close<SortIcons /></th>
                          <th>Tp<SortIcons /></th>
                          <th>Sl<SortIcons /></th>
                          <th>Lots<SortIcons /></th>
                          <th>Commission<SortIcons /></th>
                          <th>Profit<SortIcons /></th> */}
                        </tr>
                      </thead>
                      {!isLoadingnew && <tbody>
                        {(tradingHistoryList && tradingHistoryList.length > 0 && !isLoadingnew) &&
                          tradingHistoryList.map((tradingHistory, index) => (
                            <tr key={index}>
                              <td>{++index}</td>
                              <td className="status-white">{tradingHistory.trade_id}</td>
                              <td>{(tradingHistory.symbol) ? tradingHistory.symbol.name : '-'}</td>
                              <td>{tradingHistory.side == 'buy' ? (
                                <span className="td-status status-green4">Buy</span>
                              ) : (
                                <span className="td-status status-red3">Sell</span>
                              )}</td>
                              <td>{anotherFormatDate(tradingHistory.open_date)}</td>
                              <td>{tradingHistory.open_price}</td>
                              <td>{anotherFormatDate(tradingHistory.close_date)}</td>
                              <td>{tradingHistory.close_price}</td>
                              <td>{tradingHistory.take_profit != '' ? tradingHistory.take_profit : '-'}</td>
                              <td>{tradingHistory.stop_loss != '' ? tradingHistory.stop_loss : '-'}</td>
                              <td>{tradingHistory.lots}</td>
                              <td>{tradingHistory.commission != '' ? tradingHistory.commission : '-'}</td>
                              <td>
                                {
                                  tradingHistory.profit > 0 ? (
                                    <span className="td-status status-green">${(tradingHistory.profit).toFixed(2)}</span>
                                  ) : tradingHistory.loss > 0 ? (
                                    <span className="td-status status-red">-${(tradingHistory.loss).toFixed(2)}</span>
                                  ) : (
                                    <span>$0</span>
                                  )
                                }
                              </td>
                            </tr>
                          ))
                        }

                      </tbody>
                      }
                    </table>

                  </div>
                  {(isLoadingnew) && (
                    <div className="table-skeletant-bx">
                      <div className="skeletant-bx skeletant-design sh-49"></div>
                      <div className="skeletant-bx skeletant-design sh-49"></div>
                      <div className="skeletant-bx skeletant-design sh-49"></div>
                      <div className="skeletant-bx skeletant-design sh-49"></div>
                      <div className="skeletant-bx skeletant-design sh-49"></div>
                    </div>
                  )}

                  <div className="empty-box">
                    {(tradingHistoryList.length <= 0) &&
                      <EmptyBox className="empty-div-bx" eh="Data is not found" esh="Try adjusting filters to get results." />
                    }
                  </div>

                  <div className="pagenation-filter d-none">
                    <div className="pf-left">
                      <div className="pf-label">Go to</div>
                      <div className="pf-input">
                        <input type="number" placeholder="Page" value={goPageTradingHistory} onChange={onChangePageTradingHistory} />
                      </div>
                    </div>
                    <div className="pf-right">
                      <div className="pf-pagination">
                        <div className="pf-btn" onClick={changePrevPageTradingHistory}>Prev</div>
                        <div className="pf-text">
                          <div>{pageTradingHistory}</div>
                          <span>/</span>
                          <div>{totalPagesTradingHistory}</div>
                        </div>
                        <div className="pf-btn pb-right" onClick={changeNextPageTradingHistory}>Next</div>
                      </div>
                    </div>
                  </div>

                  {(tradingHistoryList && tradingHistoryList.length > 0 && !isLoading) &&
                    <Pagination
                      currentPage={pageTradingHistory}
                      totalPages={totalPagesTradingHistory}
                      onPageChange={onChangePageTradingHistory}
                      prev={changePrevPageTradingHistory}
                      next={changeNextPageTradingHistory}
                    />
                  }

                </div>
              </div>


              {/* --- Disclaimer alert message --- */}
              <div className="col-12">
                <div class="disclaimer-bx">
                  <div className="db-icon">

                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.63498 0.679086C8.52202 0.384641 9.47796 0.384641 10.365 0.679086C11.2484 0.972313 11.942 1.66776 12.6388 2.64488C13.3333 3.61875 14.1007 4.97663 15.0898 6.727L15.1287 6.79572C16.118 8.54635 16.8854 9.90417 17.3636 11.0053C17.8442 12.1118 18.0835 13.0672 17.8925 13.985C17.7003 14.9091 17.2261 15.7495 16.5357 16.3847C15.8468 17.0183 14.9089 17.2855 13.728 17.4139C12.5537 17.5416 11.0177 17.5416 9.04068 17.5416H9.04062H8.95937H8.95931C6.98231 17.5416 5.44626 17.5416 4.27201 17.4139C3.09105 17.2855 2.15315 17.0183 1.46434 16.3847C0.773842 15.7495 0.299723 14.9091 0.107451 13.985C-0.0835115 13.0672 0.155823 12.1118 0.636369 11.0053C1.11459 9.90417 1.88195 8.54635 2.87131 6.79571L2.91014 6.727L2.91015 6.72698L2.91016 6.72697C3.89934 4.97662 4.66673 3.61875 5.36121 2.64488C6.05801 1.66776 6.7516 0.972313 7.63498 0.679086ZM8.16666 13.1666C8.16666 12.7063 8.53808 12.3333 8.99626 12.3333H9.00372C9.46189 12.3333 9.83332 12.7063 9.83332 13.1666C9.83332 13.6268 9.46189 13.9999 9.00372 13.9999H8.99626C8.53808 13.9999 8.16666 13.6268 8.16666 13.1666ZM8.16666 9.83325C8.16666 10.2935 8.53975 10.6666 8.99999 10.6666C9.46023 10.6666 9.83332 10.2935 9.83332 9.83325V6.49992C9.83332 6.03968 9.46023 5.66659 8.99999 5.66659C8.53975 5.66659 8.16666 6.03968 8.16666 6.49992L8.16666 9.83325Z" fill="#E03137" />
                    </svg>

                  </div>
                  <div class="db-inner">
                    <div class="db-heading">Disclaimer</div>
                    <div class="db-text">Trading results on this dashboard are informative only. Real-time trading updates can be monitored through the trading platform. The above account statistics are automatically updated periodically when you have active trade(s). In case of any discrepancies, please be patient for the data to sync, if the issue still persists please contact us through help center.</div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </>
      }

      {/* --- Credentials Modal --- */}
      <Modal className="zoom custom-content" centered show={isCredentialsModal} onHide={handleCredentialsModalClose}>
        <div className="custom-modal-header">
          <div className="cmh-lable">Account Credentials</div>
          <div className="cmh-sub-lable">#{accountNumber}</div>

          <CloseIcon onClick={handleCredentialsModalClose} />
        </div>

        <div className="custom-modal-body">
          <div className="challenge-credentials-bx">
            <div className={"credential-item " + email != '' ? 'd-none' : ''}>
              <div className="credential-label">Email</div>
              <div className="credential-data">{email}<span className="credential-icon" onClick={() => copyClick(email)}><Icons.CopySvg /></span></div>
            </div>
            <div className="credential-item">
              <div className="credential-label">Username</div>
              <div className="credential-data">{accountNumber}<span className="credential-icon" onClick={() => copyClick(accountNumber)}><Icons.CopySvg /></span></div>
            </div>
            <div className="credential-item">
              <div className="credential-label">Password</div>
              <div className="credential-data">{masterPassword}<span className="credential-icon" onClick={() => copyClick(masterPassword)}><Icons.CopySvg /></span></div>
            </div>
            <div className="credential-item">
              <div className="credential-label">Server</div>
              <div className="credential-data">Winprofx-Live<span className="credential-icon" onClick={() => copyClick("Winprofx-Live")}><Icons.CopySvg /></span></div>
            </div>
            <div className="credential-item">
              <div className="credential-label">Platform</div>
              <div className="credential-data">Metatrader 5 <span className="credential-icon" onClick={() => copyClick("Metatrader 5")}><Icons.CopySvg /></span></div>
            </div>
          </div>
          <div className="mt-3 mb-4">
            <div className="common-btn cb-white-fill mx-auto"><span>Open META TRADER 5</span></div>
          </div>
        </div>
      </Modal>

      {/* --- Analysis Modal --- */}
      <Modal className="zoom custom-content" centered show={isAnalysisModal} onHide={handleAnalysisModalClose}>
        <div className="custom-modal-header">
          <div className="cmh-lable">{snapShotTitle}</div>

          <CloseIcon onClick={handleAnalysisModalClose} />
        </div>

        <div className="custom-modal-body">
          <div className="common-data-bx">

            <div className="cdb-item">
              <div className="cdb-label">Number of days</div>
              <div className="cdb-data">{numberOfDays}</div>
            </div>

            <div className="cdb-item">
              <div className="cdb-label">Total trades taken</div>
              <div className="cdb-data">{totalTradesTaken > 0 ? totalTradesTaken.toFixed(2) : 0}</div>
            </div>

            <div className="cdb-item">
              <div className="cdb-label">Average trades per day</div>
              <div className="cdb-data">{avgTradesPerDay}</div>
            </div>

            <div className="cdb-item">
              <div className="cdb-label">Total lots used</div>
              <div className="cdb-data">{totalLotsUsed > 0 ? totalLotsUsed.toFixed(2) : 0}</div>
            </div>

            <div className="cdb-item">
              <div className="cdb-label">Average lots used</div>
              <div className="cdb-data">{avgLotsUsed > 0 ? avgLotsUsed.toFixed(2) : 0}</div>
            </div>

            <div className="cdb-item">
              <div className="cdb-label">Biggest win</div>
              <div className="cdb-data status-green">{biggestWin > 0 ? "$" + (biggestWin.toFixed(2)) : 0}</div>
            </div>

            <div className="cdb-item">
              <div className="cdb-label">Biggest loss</div>
              <div className="cdb-data status-red">{biggestLoss > 0 ? "$" + (biggestLoss.toFixed(2)) : 0}</div>
            </div>

            <div className="cdb-item">
              <div className="cdb-label">Positive days</div>
              <div className="cdb-data">{positiveDay}</div>
            </div>
            <div className="cdb-item">
              <div className="cdb-label">Negative days</div>
              <div className="cdb-data">{negativeDay}</div>
            </div>

          </div>
        </div>
      </Modal>

      {/* --- Snapshot Modal --- */}
      <Modal className="zoom custom-content" centered show={isSnapshotModal} onHide={handleSnapshotModalClose}>
        <div className="custom-modal-header">
          <div className="cmh-lable">Loss</div>

          <CloseIcon onClick={handleSnapshotModalClose} />
        </div>

        <div className="custom-modal-body">
          <div className="common-data-bx">

            <div className="cdb-item">
              <div className="cdb-label">Number of days</div>
              <div className="cdb-data">12</div>
            </div>

            <div className="cdb-item">
              <div className="cdb-label">Total trades taken</div>
              <div className="cdb-data">15</div>
            </div>

            <div className="cdb-item">
              <div className="cdb-label">Average trades per day</div>
              <div className="cdb-data">8.5</div>
            </div>

            <div className="cdb-item">
              <div className="cdb-label">Total lots used</div>
              <div className="cdb-data">0.006</div>
            </div>

            <div className="cdb-item">
              <div className="cdb-label">Average lots used</div>
              <div className="cdb-data">0.08</div>
            </div>

            <div className="cdb-item">
              <div className="cdb-label">Biggest win</div>
              <div className="cdb-data status-green">$3.32</div>
            </div>

            <div className="cdb-item">
              <div className="cdb-label">Biggest loss</div>
              <div className="cdb-data status-red">-$0.7</div>
            </div>

            <div className="cdb-item">
              <div className="cdb-label">Positive days</div>
              <div className="cdb-data">2</div>
            </div>

            {/* <div className="cdb-item">
                  <div className="cdb-label">Avg positive day</div>
              <div className="cdb-data status-green">${}</div>
              </div> */}

            <div className="cdb-item">
              <div className="cdb-label">Negative days</div>
              <div className="cdb-data">5</div>
            </div>

            {/* <div className="cdb-item">
                  <div className="cdb-label">Avg negative day</div>
                  <div className="cdb-data status-red">0</div>
              </div> */}

            {/* <div className="cdb-item">
                  <div className="cdb-label">Highest recorded equity</div>
                  <div className="cdb-data">$26,257.25</div>
              </div> */}

          </div>
        </div>
      </Modal>

      <FlashMessage type="success" isVisible={requestSubmitSuccess} message={requestSubmitSuccessMsg} />
      <FlashMessage type="error" isVisible={requestSubmitError} message={requestSubmitErrorMsg} />
    </>
  )
}
